import { ForbiddenIcon } from '@/assets/icons';

export const Forbidden = () => {
  return (
    <div className="h-full flex flex-col items-center justify-center bg-transparent overflow-y-auto">
      <ForbiddenIcon className="flex-shrink-0" />
      <h1 className="text-[32px] font-bold text-primary-darkest mt-10 mb-3">Access Denied!</h1>
      <span className="font-medium text-base text-neutral-7">
        Sorry, we don&apos;t have permission to view this page.
      </span>
    </div>
  );
};
